var React = require('react');
var ReactDOM = require('react-dom');
var Barcode = require('react-barcode');
 
class BarcodeCom extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        value: this.props.value,
      };
    }
  
    render(){
        return(
            <div>

            <Barcode
            value={this.state.value}
            width={this.state.width}
            height={this.state.height}
            format={this.state.format}
            displayValue={this.state.displayValue}
            fontOptions={this.state.fontOptions}
            font={this.state.font}
            textAlign={this.state.center}
            textPosition={this.state.textPosition}
            textMargin={this.state.textMargin}
            fontSize={this.state.fontSize}
            background={this.state.background}
            lineColor={this.state.lineColor}
            margin={this.state.margin}
            marginTop={this.state.marginTop}
            marginBottom={this.state.marginBottom}
            marginLeft={this.state.marginLeft}
            marginRight={this.state.marginRight}
            />
        </div>
        );
    }
}

export default BarcodeCom